import { Field, useField } from "formik";
import FormField from "./FormField";

const TextField = ({ name, label, type = "text", placeholder = "" }) => {
  const [field, meta] = useField(name);

  return (
    <FormField label={label} name={name}>
      <Field
        type={type}
        name={name}
        placeholder={placeholder}
        className={`w-full p-4 border placeholder-[#afb6b9] rounded-lg disabled:text-dark-gray/50 focus:ring-2 focus:ring-primary focus:border-transparent ${
          field.value === "" ? "text-[#afb6b9]" : ""
        } ${meta.touched && meta.error ? "border-red-500" : "border-dark-gray/50"}`}
      />
    </FormField>
  );
};

export default TextField;
